import {
  Component,
  OnInit,
  Input,
  OnChanges,
  SimpleChanges,
  AfterViewInit,
  OnDestroy
} from "@angular/core";
import { RegionWiseOtifBreakupService } from "./services/widget-region-wise-itif-breakup.service";
import * as Highcharts from "highcharts";
import addMore from "highcharts/highcharts-more";
import { TranslateService } from "@ngx-translate/core";
import * as HSET from "./settings";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
addMore(Highcharts);
@Component({
  selector: "widget-regionwise-otif-breakup",
  templateUrl: "./widget-regionwise-otif-breakup.component.html",
  styleUrls: ["./widget-regionwise-otif-breakup.component.scss"],
  providers: [RegionWiseOtifBreakupService]
})
export class WidgetRegionwiseOtifBreakupComponent
  implements OnInit, OnChanges, AfterViewInit, OnDestroy {
  private unsubscribe: Subject<void> = new Subject();
  data;
  @Input() TITLE: string;
  @Input() OPTIONS;
  @Input() FILTERS;

  dropdownItems = [];
  selectedOption = [];
  highcharts: typeof Highcharts = Highcharts;
  chartOptions = null;
  errorMessage = "";
  partedData;
  selectedValue = "";
  mockChart = null;

  constructor(
    private translateService: TranslateService,
    private dataService: RegionWiseOtifBreakupService
  ) { }

  ngAfterViewInit() {
    this.getRegionWiseOtifBreakupData();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      JSON.stringify(changes.FILTERS.currentValue) !==
      JSON.stringify(changes.FILTERS.previousValue) &&
      !changes.FILTERS.firstChange
    ) {
      this.getRegionWiseOtifBreakupData();
    }
  }

  ngOnInit() {
    this.translateService
      .get("PERFORMANCE.DELIVERY.REGIONWISE_OTIF_BREAKUP")
      .pipe(takeUntil(this.unsubscribe)).subscribe(text => {
        this.OPTIONS.title = this.OPTIONS.title || text;
      });
  }

  getRegionWiseOtifBreakupData() {
    this.chartOptions = null;
    this.mockChart = null;
    this.errorMessage = "";
    this.dropdownItems = [];
    this.dataService
      .getRegionWiseOtifBreakupData(this.OPTIONS.api, this.FILTERS)
      .pipe(takeUntil(this.unsubscribe)).subscribe(
        chartData => {
          if (chartData === null) {
            this.errorMessage = "ERROR_MSG.NO_DATA";
            this.mockChart = HSET.chartData;
          } else {
            this.dropdownItems = chartData.buckets;
            const indexOfOTIF = chartData.buckets.indexOf("SLA Success");
            this.selectedOption = [
              indexOfOTIF > -1
                ? chartData.buckets[indexOfOTIF]
                : chartData.buckets[0]
            ];
            this.partedData = chartData.partedData;
            this.selectedValue =
              indexOfOTIF > -1
                ? chartData.buckets[indexOfOTIF]
                : chartData.buckets[0];
            const part =
              indexOfOTIF > -1
                ? this.partedData[indexOfOTIF]
                : this.partedData[0];
            const chart = this.dataService.processPartForChart(part);
            this.chartOptions = this.dataService.createChart(
              chart,
              this.OPTIONS
            );
          }
        },
        error => {
          this.errorMessage = "ERROR_MSG.SYSTEM_ERROR";
          this.mockChart = HSET.chartData;
        }
      );
  }

  public dropdownChange(value: any): void {
    const chart = this.dataService.processPartForChart(
      this.partedData[this.dropdownItems.indexOf(value)]
    );
    this.chartOptions = this.dataService.createChart(chart, this.OPTIONS);
  }
  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
